import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UploadService} from "./service/upload.service";
import {UploadDialogDto, UploadDialogResult} from "./dto/upload-dialog.dto";
import {lastValueFrom, Observable, tap} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'shared-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.scss',
})
export class UploadImageComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  selectedFiles: File[] = [];
  uploadedPath: string[] = [];
  imagePreviews: string[] = [];
  progressUpload: Observable<number>
  errorMessage: string;
  imageTmpEndpoint = environment.baseUrl + "/upload/image/tmp/";

  constructor(
    private uploadService: UploadService,
    public dialogRef: MatDialogRef<UploadImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadDialogDto
  ) {}

  ngOnInit(): void {
    this.uploadedPath = this.data.imagesUploaded
    this.uploadService.progressUpload = 100
    this.progressUpload = this.uploadService.progressUpload
  }

  onFileSelected(event: Event) {
    this.imagePreviews = [];
    this.errorMessage = "";
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files) {
      this.errorMessage = "Tidak ada file yang dipilih.";
      return;
    }
    this.selectedFiles = Array.from(inputElement.files);
    if (this.selectedFiles.length > 5) {
      this.errorMessage = "Tidak boleh pilih lebih dari 5 gambar";
      return;
    }

    if (inputElement.files && inputElement.files.length > 0) {
      for (let i = 0; i < inputElement.files.length; i++) {
        const file: File = inputElement.files[i];
        this.createImagePreview(file);
      }
    }
  }

  createImagePreview(file: File) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagePreviews.push(event.target.result);
    };
    reader.readAsDataURL(file);
  }

  async uploadImage() {
    if (this.selectedFiles.length === 0) {
      console.error("Tidak ada file yang dipilih.");
      return;
    }

    const uploadData = new FormData();
    for (let file of this.selectedFiles) {
      file = await this.uploadService.compressImage(file)
      uploadData.append('files', file, file.name);
    }

    this.uploadService.upload(this.data.companyCode, uploadData)
      .pipe(
        tap((data) => {
          if (this.uploadedPath && this.uploadedPath.length > 0) {
            this.uploadedPath = [...this.uploadedPath, ...data]
          } else {
            this.uploadedPath = data
          }

          this.onClose();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        error: (err) => {
          console.log(err)
        }
      })
  }

  onEditImage(filename: string) {
    this.data.filename = ""
    this.uploadedPath = this.uploadedPath ? this.uploadedPath.filter((i) => i != filename) : []
  }

  async onDeleteImage(filename: string) {
    this.uploadedPath = this.uploadedPath ? this.uploadedPath.filter((i) => i != filename) : []
    await lastValueFrom(this.uploadService.delete(this.data.companyCode, filename))
    this.onClose()
  }

  onClose(): void {
    let data: UploadDialogResult = {
      imagesPath: this.uploadedPath
    }
    this.dialogRef.close(data);
  }
}
